export const YMME_NAME = 'addVehicleModalYmme'
export const LICENSE_PLATE_NAME = 'addVehicleModalLicensePlate'

export const TireSizesNotFoundContinueBtnText = 'CLOSE'
